import React from "react";
import { Fragment } from "react";
import AboutData from "../../../common/assets/data/about/about";
import InnerBannerSection from "../../utility/ui-components/innerPageBanner";
import ContentSection from "./contentSections";
import TeamSection from "./teamSections";

function About() {
  const data = AboutData;
  window.scrollTo(0 , 0);
  return (
    <Fragment>
      <InnerBannerSection content={data.PageBanner} />
      <ContentSection />
      {/* <TeamSection /> */}
    </Fragment>
  );
}

export default About;
